import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'aa-lead-demo',
    templateUrl: './lead-demo.component.html',
    styleUrls: ['./lead-demo.component.scss'],
    standalone: false
})
export class LeadDemoComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
